import { Final } from './Final';

export const Finals = {
  Final,
};

export const finalsList = [Final] as const;

export const finalsMapping = {
  [Final.config.name]: Final,
} as const;
